import { Box } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { UPDataGrid } from 'components/data-grid';
import { PayrollAddNewItemButton } from 'modules/companies/payroll/styles';
import { SectionContainer } from 'modules/companies/styles';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'store';
import { setMenuStatusAction } from 'store/actions/menu-actions';
import { getAccountManagersAction } from 'store/actions/superadmins-actions';
import { accountManagersSelector } from 'store/selectors/apiusers-selectors';
import { activeMenuItemSelector } from 'store/selectors/menu-selectors';
import {
  ACCOUNT_MANAGERS__ADD_NEW,
  ACCOUNT_MANAGERS__ADD_NEW_BUTTON,
  GENERAL__FIRST_NAME,
  GENERAL__LAST_NAME,
  GENERAL__USERNAME,
  MENU__USERS,
} from 'translations/constants';
import IUser from 'types/superadmin/ISuperAdmin';
import EditApiUser from './EditApiUser';
import { UsersButtonsRow } from './styles';

const AccountManagers = () => {
  const dispatch = useAppDispatch();
  const [t] = useTranslation();

  const users = useAppSelector(accountManagersSelector);
  const activeItem = useAppSelector(activeMenuItemSelector);

  const [rows, setRows] = useState<IUser[]>([]);
  const [, setRowOnHover] = useState<number>(null);
  const [isAddModalOpen, setIsAddModalOpen] = useState<boolean>(false);

  const columns: GridColDef[] = [
    { field: 'id', headerName: '', hide: true },
    { field: 'firstName', headerName: t(GENERAL__FIRST_NAME), width: 200 },
    { field: 'lastName', headerName: t(GENERAL__LAST_NAME), width: 200 },
    { field: 'email', headerName: t(GENERAL__USERNAME), width: 300 },
  ];

  const onOpenAddModal = event => {
    event.preventDefault();
    event.stopPropagation();
    setIsAddModalOpen(true);
  };

  const onCloseAddEditModal = () => {
    setIsAddModalOpen(false);
  };

  useEffect(() => {
    if (activeItem !== t(MENU__USERS)) {
      dispatch(setMenuStatusAction(t(MENU__USERS)));
    }
  }, [activeItem, dispatch, t]);

  useEffect(() => {
    dispatch(getAccountManagersAction());
  }, [dispatch]);

  useEffect(() => {
    if (users) {
      setRows(users);
    }
  }, [users]);

  return (
    <SectionContainer sx={{ paddingTop: '16px' }}>
      <UsersButtonsRow>
        <PayrollAddNewItemButton text={`+ ${t(ACCOUNT_MANAGERS__ADD_NEW_BUTTON)}`} onClick={onOpenAddModal} />
      </UsersButtonsRow>
      <Box sx={{ height: '65vh', width: '100%' }}>
        <UPDataGrid
          rows={rows}
          columns={columns}
          getRowId={row => row.id}
          setRowOnHover={setRowOnHover}
          withCheckboxes={false}
        />
        {isAddModalOpen && (
          <EditApiUser
            open
            onClose={onCloseAddEditModal}
            title={t(ACCOUNT_MANAGERS__ADD_NEW)}
            isEdit={false}
            isForAccountManager
          />
        )}
      </Box>
    </SectionContainer>
  );
};

export default AccountManagers;
